import { Injectable, OnInit, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { map, catchError, retry, takeUntil } from 'rxjs/operators';
import { _ } from 'underscore';
import { Router } from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { PostEnergyInfo } from 'src/app/shared/models/postenergyinfo';
import * as moment from 'moment-timezone';
import { of } from 'rxjs';
import { delay } from 'rxjs/operators';
const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class ResidentialService implements OnInit {
  private messageSource = new BehaviorSubject({});
  private unselectSource = new BehaviorSubject({});
  currentunSelect = this.unselectSource.asObservable();
  currentMessage = this.messageSource.asObservable();
  url = environment.api_url;
  app_url = environment.aap_url;
  resinputQuestions;
  userResponse = {
    userResponses: [],
  };
  widthoutQuestionUserRequest;
  REP_movin_Dates = [];
  REP_switch_Dates = [];
  REP_Holiday_Dates = [];
  REP_Move_Max_Date;
  REP_SWI_Max_Date;
  REP_Move_Min_Date;
  REP_SWI_Min_Date
  actualQuestions;
  currentId;
  service;
  property;
  rent_own;
  switchType;
  nextId;
  messervicetype = false;
  deviceWidth;
  selectedType;
  selectedNextId;
  selectedTermId;
  user;
  filteredQues;
  selectAddress;
  selectESIID;
  updateResponse = new EventEmitter();
  isStartOver = false;
  setConfirmationStatusDetails;
  // For geo-map
  address;
  // For help icon flag
  setShowHelp = new EventEmitter();
  // For blog icon text
  setShowArticle = new EventEmitter();
  // For service icon flag
  setShowService = new EventEmitter();
  // For StatusObj
  questionnaireStatusObj;
  esiid;
  tdspindicator
  SWitchHoldindicator
  // For renewal flow
  questionFlowType;
  questionId;
  serviceResObj;
  processType;
  childrens;
  adults;
  errorModal = false;
  attachments = [];
  private dataStringSource = new Subject<string>();
  dataString$ = this.dataStringSource.asObservable();
  private switchDataStringSource = new Subject<string>();
  switchDataString$ = this.switchDataStringSource.asObservable();
  private enableStepNameSource = new Subject<string>();
  enableStepName = this.enableStepNameSource.asObservable();
  enrollmentPostResult;
  enrollmentPostObject;
  IPAddress = "";
  promoCode: string;
  providerLogos = {
    PulsePower:
      'https://res.cloudinary.com/honest-gorilla/image/upload/v1614010092/Static%20images/PulsePower-logo-150_b6jnwl.jpg',
    NewPowerTexas:
      'https://res.cloudinary.com/honest-gorilla/image/upload/v1614009445/Static%20images/NewPowerTexas-logo-150_jt887q.jpg',
    Bulb: 'https://res.cloudinary.com/honest-gorilla/image/upload/v1614010722/Static%20images/Bulb_Energy_company_logo_uasj5h.png',
    ChariotEnergy:
      'https://res.cloudinary.com/honest-gorilla/image/upload/v1594472361/Static%20images/chariot-logo_dra39n.png',
    ChangeEnergy4:
      'https://res.cloudinary.com/honest-gorilla/image/upload/c_scale,w_138/v1616771924/Static%20images/4change_energy_logoV2-01_yzyfem.svg',
  };
  contactInfoDetails: any;
  private unsubscribe$: Subject<void> = new Subject<void>();
  zipCode: any;
  utilityName: string;
  creditCheckResult4CE: {
    depositRequired4CE: any;
    depositAmount4CE: number;
    autoPay4CE: boolean;
  };
  depositPaymentOption: {
    accountNumber: string;
    clientJavaScriptUrl: string;
    clientJavaScriptHost: string;
    clientJavaScriptAccessToken: string;
  };
  beginCustomerEnrollmentRequest: any;
  completeCustomerEnrollmentPostObject: any;
  ConfirmAPIEnrollmentResult: any;
  preRecommendation: any;
  providerContact: any;
  tduRates: any;
  questionPercentage: string;
  notificationObj = {};
  dateModel: any;
  newFormattedAddress: string;
  recommendations: any[];
  constructor(
    private http: HttpClient,
    private https: HttpClient,
    private router: Router,
    private modalService: BsModalService
  ) {

    this.getIPAddress().then(ipAddress => {

      this.IPAddress = ipAddress

    });

  }

  public getQuestions() {
    return this.http
      .get('assets/questionnaire.json')
      .pipe(map((response) => response));
  }

  public getUtilies(zipcode: any, address, apartment,utilityName = null) {
    const zipJson = JSON.stringify({
      Zip: zipcode,
      Address: address,
      Apartment: apartment,
      utilityName: utilityName
    });
    return this.http.post(this.url + '/getUtilities', zipJson, httpOptions);
  }

  public getUtiliessignuporder(zipcode: any) {
    const zipJson = JSON.stringify({
      Zip: zipcode,
    });
    return this.http.post(this.url + '/getUtilities', zipJson, httpOptions);
  }

  public setQuestions(questions) {
    this.resinputQuestions = questions;
    this.actualQuestions = this.resinputQuestions;
  }

  public getQues() {
    return this.resinputQuestions;
  }

  public setServiceType(selectedValue) {
    this.selectedType = selectedValue;
  }

  public setNextId(selectedIdValue) {
    this.selectedNextId = selectedIdValue;
  }

  public setNextTermId(term: {}) {
    if (term['termValue']) {
      this.selectedTermId = term['termValue'];
    }
  }

  public setUser(user) {
    this.user = user;
  }

  public updateResponses(response) {
    if(this.userResponse != null)
    {

    
    const foundElem = _.findWhere(this.userResponse.userResponses, {
      res_question_id: response.res_question_id,
    });
    if (foundElem === undefined) {
      if (this.userResponse && this.userResponse.userResponses === null) {
        this.userResponse = {
          userResponses: [],
        };
      }
      this.userResponse.userResponses.push(response);
    } else {
      this.userResponse.userResponses = _.map(
        this.userResponse.userResponses,
        function (item, index) {
          if (
            item &&
            response &&
            item.res_question_id === response.res_question_id
          ) {
            item = response;
          }
          return item;
        }
      );
    }
  }

    var a  = JSON.parse(sessionStorage.getItem('widthoutQuestionUserRequest'));
    if(a != null)
    {
      this.userResponse = {
        userResponses: [],
      };
      sessionStorage.removeItem('userResponse');
    }else
    {
      sessionStorage.setItem('userResponse', JSON.stringify(this.userResponse));
      sessionStorage.setItem(
        'questionStatusObj',
        JSON.stringify(this.questionnaireStatusObj)
      );

    }

   

    this.questionnaireStatusObj = {
      questionStatus: 'Quitted',
      questionStep: this.currentId,
      type: this.service,
    };
  }

  public messageService(message: {}) {
    
    if (message['currentId']) {
      this.currentId = message['currentId'];
    }
    if (message['service']) {
      this.service = message['service'];
      if (message['service'] === 'Switching Providers') {
        const filtered = _.filter(this.actualQuestions, function (item) {
          return (
            item.service === 'Switching Providers' || item.service === 'Both'
          );
        });
        this.resinputQuestions = filtered;
      } else if (message['service'] === 'New Service') {
        const filtered = _.filter(this.actualQuestions, function (item) {
          return item.service === 'New Service' || item.service === 'Both';
        });
        this.resinputQuestions = filtered;
      }
    }
    if (message['rent_own']) {
      this.rent_own = message['rent_own'];
    }
    if (message['nextId']) {
      this.nextId = message['nextId'];
    }
    if (message['currentId'] === '000') {
      this.userResponse = {
        userResponses: [],
      };
    }
    this.messageSource.next(message);
  }

  public saveuserResponses() {
    if (this.user) {
      if (
        !this.questionnaireStatusObj &&
        _.isEmpty(this.questionnaireStatusObj)
      ) {
        this.questionnaireStatusObj = JSON.parse(
          sessionStorage.getItem('questionStatusObj')
        );
      }
      const user = {
        _id: this.user._id,
        accountId: this.user.accountId,
        questionStatusObj: this.questionnaireStatusObj,
        processType: this.processType,
      };
      if (this.esiid && !_.isEmpty(this.esiid)) {
        user['esiid'] = this.esiid;
      }
      if (
        _.isEmpty(this.userResponse) ||
        _.isEmpty(this.userResponse.userResponses)
      ) {
        this.userResponse = JSON.parse(sessionStorage.getItem('userResponse'));
      }
      user['questionnarieObj'] = this.userResponse;
      user['type'] = this.questionFlowType;
      if (!_.isEmpty(sessionStorage.getItem('questionId'))) {
        user['questionId'] = sessionStorage.getItem('questionId').toString();
      }
      return this.http
        .post(this.url + '/updateAccount', user, httpOptions)
        .pipe(retry(1));
    }
  }

  public updateResponsesOnly() {
    if (this.user) {
      if (
        !this.questionnaireStatusObj &&
        _.isEmpty(this.questionnaireStatusObj)
      ) {
        this.questionnaireStatusObj = JSON.parse(
          sessionStorage.getItem('questionStatusObj')
        );
      }
      const user = {
        _id: this.user.accountId,
        accountId: this.user.accountId,
        questionStatusObj: this.questionnaireStatusObj,
        processType: this.processType,
      };
      if (this.esiid && !_.isEmpty(this.esiid)) {
        user['esiid'] = this.esiid;
      }
      if (
        _.isEmpty(this.userResponse) ||
        _.isEmpty(this.userResponse.userResponses)
      ) {
        this.userResponse = JSON.parse(sessionStorage.getItem('userResponse'));
      }
      user['questionnarieObj'] = this.userResponse;
      user['type'] = this.questionFlowType;
      if (!_.isEmpty(sessionStorage.getItem('questionId'))) {
        user['questionId'] = sessionStorage.getItem('questionId').toString();
      }
      return this.http
        .post(this.url + '/updateResponses', user, httpOptions)
        .pipe(retry(1));
    }
  }

  public getRecommendations(userObj) {
    return this.http
      .post(this.url + '/getRecommendation', userObj, httpOptions)
      .pipe(retry(1));
  }
  public getRecommendationsByUtility(userObj) {
    return this.http
      .post(this.url + '/getRecommendationsByUtility', userObj, httpOptions)
      .pipe(retry(1));
  }

  public getRecommendationsCountByUtility(userObj) {
    return this.http
      .post(this.url + '/getRecommendationsCountByUtility', userObj, httpOptions)
      .pipe(retry(1));
  }
  
  getResidentialUsage(userObj) {
    return this.http
      .post(this.url + '/getResidentialUsage', userObj)
      .pipe(retry(1));
  }

  getCustomResidentialUsage(userObj) {
    return this.http
      .post(this.url + '/getCustomResidentialUsage', userObj)
      .pipe(retry(1));
  }

  public postApiOfEnrollment(userObj) {
    return this.http
      .post(this.url + '/postDataOfEnrollment', userObj, httpOptions)
      .pipe(retry(0));
      
  }

  postApiEnergyProvidersPlanStatus(userObj) {
    return this.http
      .post(this.url + '/addEnergyProvidersStatus', userObj, httpOptions)
      .pipe(retry(1));
  }

  postApiPlanIdFailSaveToDB(userObj) {
    return this.http
      .post(this.url + '/saveApiResponseToDB', userObj, httpOptions)
      .pipe(retry(1));
  }

  getEnergyProvidersPlanStatusByID(
    providerName: string,
    utilityName: string,
    planName: string,
    productID: number
  ) {
    const objID = {
      energyProviderName: providerName,
      utilityName: utilityName,
      planName: planName,
      ProductID: productID,
    };

    return this.http.post(
      this.url + '/getEnergyProvidersByID',
      objID,
      httpOptions
    );
  }

  public postApiOfEnrollmentUpload(userObj) {
    // return this.http
    //   .post(
    //     'https://api.chariotenergy.com/api/broker/SubmitEnrollment',
    //     userObj
    //   )
    //   .pipe(retry(1));
    return this.http
      .post(this.url + '/postDataOfEnrollment', userObj, httpOptions)
      .pipe(retry(0));
  }

  public postcreatelogdata(logdata) {
    return this.http
      .post(this.url + '/savelogData', logdata, httpOptions)
      .pipe(retry(1));
  }

  public SendMessagesAfterPostOfEnrollment(messageObj) {
    return this.http
      .post(this.url + '/sendmessages', messageObj, httpOptions)
      .pipe(retry(1));
  }

  public putApiOfEnrollment(putobj) {
    return this.http
      .post(this.url + '/putDataOfEnrollment', putobj, httpOptions)
      .pipe(retry(1));
  }

  handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = `Error: ${error.error.message}`;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: Seems like there is some error. Please check back later.`;
    }
    this.errorModal = true;
    window.alert(errorMessage);
    throw new Error(errorMessage);
  }

  filter(responsess) {
    if (!_.isEmpty(responsess)) {
      this.userResponse.userResponses = responsess;
      const findService = _.findWhere(responsess, { res_question_id: '002' });
      if (!_.isEmpty(findService)) {
        this.service = findService.fieldValue;
        this.setServiceType(this.service);
        if (this.service === 'Switching Providers') {
          const filtered = _.filter(this.actualQuestions, function (item) {
            return (
              item.service === 'Switching Providers' || item.service === 'Both'
            );
          });
          this.resinputQuestions = filtered;
        } else if (this.service === 'New Service') {
          const filtered = _.filter(this.actualQuestions, function (item) {
            return item.service === 'New Service' || item.service === 'Both';
          });
          this.resinputQuestions = filtered;
        }
      }
      this.filteredQues = this.resinputQuestions;
    }
  }

  public unSelectService(message: {}) {
    this.unselectSource.next(message);
  }

  setStatus(status) {
    this.questionnaireStatusObj.questionStatus = status;
  }

  setupdateServiceTypes(service) {
    this.questionnaireStatusObj.type = service;
    sessionStorage.setItem(
      'questionStatusObj',
      JSON.stringify(this.questionnaireStatusObj)
    );
  }

  ngOnInit() {}

  // To set the help show/hide flag
  setHelpFlag(data) {
    this.setShowHelp.emit(data);
  }

  // To set the blog show/hide text
  setArticleFlag(data) {
    this.setShowArticle.emit(data);
  }

  // To set the service show/hide flag
  setServiceFlag(data) {
    this.setShowService.emit(data);
  }

  // To set the Selected Address
  public setSelectedAddress(selectedValue) {
    this.selectAddress = selectedValue;
  }

  public setSelectedESIID(selectedValue) {
    this.selectESIID = selectedValue;
  }

  

  // To load script files while component loading
  public loadScriptFiles(url: string) {
    const body = <HTMLDivElement>document.body;
    const script = document.createElement('script');
    script.innerHTML = '';
    script.src = url;
    script.async = false;
    script.defer = true;
    body.appendChild(script);
  }

  // for quit flow to avoid duplication of code
  public quitFlow() {
    const questionStatusObj =
      sessionStorage.getItem('questionStatusObj') !== undefined
        ? JSON.parse(sessionStorage.getItem('questionStatusObj'))
        : null;
    // questionStatusObj.percentage = Number(sessionStorage.getItem('percentage'));
    questionStatusObj.percentage = Number(this.questionPercentage);
    sessionStorage.setItem(
      'questionStatusObj',
      JSON.stringify(questionStatusObj)
    );
    const userResponse = sessionStorage.getItem('userResponse');
    const accountId = window.location.href.split('/').pop();
    const userObj = new HttpParams().append('hg_accountId', accountId);
    // quit flow -> if user not completed any enrollment need to check the orders length if == 0 then consider in quit flow.
    this.https
      .get(this.url + '/getOrders', { params: userObj })
      .subscribe((res: any) => {
        const ordersRes = res;
        if (!this.isStartOver && ordersRes && !_.isEmpty(ordersRes)) {
          this.router.navigate([
            'user-settings',
            JSON.parse(sessionStorage.getItem('userObj'))._id,
          ]);
        } else if (
          !this.isStartOver &&
          !_.isEmpty(sessionStorage.getItem('userObj') || _.isEmpty(ordersRes))
        ) {
          this.user = JSON.parse(sessionStorage.getItem('userObj'));
          this.user['accountId'] = this.user._id;
          if (userResponse) {
            this.userResponse = JSON.parse(
              sessionStorage.getItem('userResponse')
            );
          }
          this.questionnaireStatusObj = questionStatusObj;
          this.saveuserResponses().subscribe((res: any) => {});
          if (
            window.location.href.indexOf('recommendation') > -1 ||
            window.location.href.indexOf('energyplan-confirmation') > -1
          ) {
            const notificationObj = {
              type: 'enrollment_not_completed',
              hg_orders_id: null,
              hg_accountId: this.user._id,
              esiid: null,
              showNotification: true,
              isRead: false,
              navigation_link: null,
              buttonUrl:
                '/recommendation/single-product/' + this.user._id.toString(),
              buttonName: 'Shop Now',
              questionnairePercent: 100,
              title: 'WE NOTICED...',
              message:
                'Your energy usage profile is complete but no product has been selected. What are you waiting for?',
              processCompleted: false,
              createdDate: this.getCurrentDatePerCST,
              lastUpdatedDate: this.getCurrentDatePerCST,
              createdBy: '0',
              lastUpdatedBy: '0',
            };
            const queryObj = {
              type: 'enrollment_not_completed',
              hg_orders_id: null,
              hg_accountId: this.user._id,
              esiid: null,
              processCompleted: false,
            };

            const enrollbody = new HttpParams()
              .append('queryObj', JSON.stringify(queryObj))
              .append('updateObj', JSON.stringify(notificationObj));
            this.https
              .post(this.url + '/updateNotification', enrollbody)
              .subscribe((notifyres: any) => {
                const notifyresult = notifyres;
                if (notifyresult.statusCode === '002') {
                } else {
                  this.router.navigate([
                    'user-settings',
                    JSON.parse(sessionStorage.getItem('userObj'))._id,
                  ]);
                }
              });
          } else {
            const queryObj = {
              type: 'questionnarie_not_completed',
              hg_orders_id: null,
              hg_accountId: this.user._id,
              esiid: null,
              processCompleted: false,
            };
            const updateObj = {
              questionnairePercent: Number(questionStatusObj.percentage),
              showNotification: true,
              isRead: false,
            };
            const enrollbody = new HttpParams()
              .append('queryObj', JSON.stringify(queryObj))
              .append('updateObj', JSON.stringify(updateObj));
            this.https
              .post(this.url + '/updateNotification', enrollbody)
              .subscribe((res: any) => {
                const notifyresult = res;
                if (notifyresult.statusCode === '002') {
                } else {
                  this.router.navigate([
                    'user-settings',
                    JSON.parse(sessionStorage.getItem('userObj'))._id,
                  ]);
                }
              });
          }
          // }
        } else {
          if (!this.isStartOver) {
            this.router.navigateByUrl('/skippage');
          } else {
            this.router.navigate([
              'user-settings',
              JSON.parse(sessionStorage.getItem('userObj'))._id,
            ]);
          }
        }
      });
  }

  updateResultList(updatedList) {
    this.dataStringSource.next(updatedList);
  }

  updateSwitchServiceType(switchTypeValue) {
    this.switchDataStringSource.next(switchTypeValue);
  }

  enableStepPerMove(stepName) {
    this.enableStepNameSource.next(stepName);
  }

  validateCreatedDateTime(oldValue: Date) {
    const newValue = new Date();
    if (this.getItemDate(oldValue) <= this.getItemDate(newValue)) {
      return true;
    }
  }

  getItemDate(itemValue: Date) {
    return new Date(itemValue).getUTCDate();
  }

  getItemTime(itemValue: Date) {
    return new Date(itemValue).getTime();
  }

  validateHGAccountID(accountId) {
    return (
      sessionStorage.getItem('currentUser') !== accountId &&
      sessionStorage.getItem('currentUser') === null
    );
  }

  getEnergyProvidersPlanStatus(
    providerName: string,
    utilityName: string,
    planName: string
  ) {
    const objID = {
      energyProviderName: providerName,
      utilityName: utilityName,
      planName: planName,
    };
    return this.http.post(
      this.url + '/getEnergyProvidersPlanStatus',
      objID,
      httpOptions
    );
  }

  getPulseRates(zipcode: any) {
    const zipJson = JSON.stringify(zipcode);
    return this.http.post(this.url + '/getPulseRates', zipJson, httpOptions);
  }

  postApiOfPulseEnrollment(userObj) {
    return this.http
      .post(this.url + '/postDataOfPulseEnrollment', userObj, httpOptions)
      .pipe(retry(0));
  }

  postApiOfRhythmEnergyEnrollment(userObj) {
    return this.http
      .post(this.url + '/postApiOfRhythmEnergyEnrollment', userObj, httpOptions)
      .pipe(retry(0));
  }

  postApiOfAPGEEnergyEnrollment(userObj) {
    return this.http
      .post(this.url + '/postApiOfAPGEEnergyEnrollment', userObj, httpOptions)
      .pipe(retry(0));
  }

  postApiOfShellEnergyEnrollment(userObj) {
    return this.http
      .post(this.url + '/postApiOfShellEnergyEnrollment', userObj, httpOptions)
      .pipe(retry(0));
  }


  postApiOf4ChangeEnergyEnrollment(energyPostObject: any) {
    const userObj1 = energyPostObject;
    return this.http
      .post(
        this.url + '/postApiOf4ChangeEnergyEnrollment',
        userObj1,
        httpOptions
      )
      .pipe(retry(0));
  }

  postApiOfGEXAEnergyEnrollment(userObj) {
    const userObj1 = JSON.stringify(userObj);
    return this.http
      .post(this.url + '/postApiOfGEXAEnergyEnrollment', userObj1, httpOptions)
      .pipe(retry(0));
  }

  postApiOfTexpoEnergyEnrollment(userObj) {
    const userObj1 = JSON.stringify(userObj);
    return this.http
      .post(this.url + '/postApiOfTexpoEnergyEnrollment', userObj1, httpOptions)
      .pipe(retry(0));
  }

  postSelectedProductAPI(userObj) {
    const userObj1 = JSON.stringify(userObj);
    return this.http
      .post(this.url + '/postSelectedProductAPI', userObj1, httpOptions)
      .pipe(retry(1));
  }

  getSelectedProductDetails(hg_accountId) {
    return this.http
      .post(this.url + '/getSelectedProductDetails', hg_accountId, httpOptions)
      .pipe(retry(1));
  }

  getSelectedProductDetailForSafari() {
    return this.http
      .post(this.url + '/getSelectedProductDetailForSafari', '', httpOptions)
      .pipe(retry(1));
  }

  getDepositPendingStatus(userObj) {
    const zipJson = JSON.stringify(userObj);
    return this.http
      .post(this.url + '/getDepositPendingStatus', zipJson, httpOptions)
      .pipe(retry(1));
  }

  saveDepositPendingStatus(userObj) {
    return this.http
      .post(this.url + '/saveDepositPendingStatus', userObj, httpOptions)
      .pipe(retry(1));
  }

  getProviderContactInfo() {
    return this.http.get('assets/energy_providers_contact.json');
  }

  getProviderContactInfoDetails(providerName, utilityName) {
    const userObj = {
      energyProviderName: providerName,
      utilityName: utilityName,
    };

    return this.http
      .post(this.url + '/getProviderContactInfo', userObj, httpOptions)
      .pipe(retry(1));
  }

  updateNotificationObject(nofificationObj) {
    this.http
      .post(
        this.url + '/saveNotificationWindowClose',
        nofificationObj,
        httpOptions
      )
      .subscribe((notifyres: any) => {
        const notifyresult = notifyres;
      });
  }

  getServiceTypeDateObj() {
    const dateObj = new Date();
    return (
      [dateObj.getMonth() + 1, dateObj.getDate(), dateObj.getFullYear()].join(
        '/'
      ) +
      ' ' +
      [
        dateObj.getUTCHours(),
        dateObj.getUTCMinutes(),
        dateObj.getUTCSeconds(),
      ].join(':')
    );
  }

  get4CEProducts() {
    return this.http.get(this.url + '/get4CEProducts').pipe(retry(1));
  }

  setupTransactPaymentAccounts(user: {}) {
    return this.http
      .post(this.url + '/setupTransactPaymentAccounts', user, httpOptions)
      .pipe(retry(1));
  }

  setupBeginCustomerEnrollment(user: {}) {
    const userObj1 = JSON.stringify(user);
    return this.http
      .post(
        this.url + '/postApiOf4ChangeEnergyBeginEnrollment',
        userObj1,
        httpOptions
      )
      .pipe(retry(0));
  }

  saveCompleteCustomerEnrollment(userObj: { postObject: any; apiURL: any }) {
    const userObj1 = JSON.stringify(userObj);
    return this.http
      .post(this.url + '/saveCompleteCustomerEnrollment', userObj1, httpOptions)
      .pipe(retry(1));
  }

  saveGEXACompleteEnrollment(userObj: any) {
    const userObj1 = JSON.stringify(userObj);
    return this.http
      .post(this.url + '/saveGEXACompleteEnrollment', userObj1, httpOptions)
      .pipe(retry(1));
  }

  setupSuccessCustomerEnrollment(userObj: { postObject: any; apiURL: any }) {
    const userObj1 = JSON.stringify(userObj);
    return this.http
      .post(this.url + '/saveCompleteCustomerEnrollment', userObj1, httpOptions)
      .pipe(retry(1));
  }

  getTduIdForAllUtilityNames() {
    return this.http
      .get(this.url + '/get4CETduIdForAllUtilityNames', httpOptions)
      .pipe(retry(1));
  }

  saveOrderDetailsForPrepaidProviders(userObj) {
    const userObj1 = JSON.stringify(userObj);
    return this.http
      .post(
        this.url + '/saveOrderDetailsForPrepaidProviders',
        userObj1,
        httpOptions
      )
      .pipe(retry(1));
  }

  renameEnergyProviderName(itemName: string) {
    itemName = itemName.replace(/\s/g, '');
    return this.providerLogos[
      itemName === '4ChangeEnergy' ? `${itemName.slice(1)}4` : itemName
    ];
  }

  autoGenerateYears() {
    let years: number[] = [];
    let currentYear: number = new Date().getFullYear(),
      maxYear = currentYear + 10;
    for (let i = currentYear; i < maxYear; i++) {
      years.push(i);
    }
    return years;
  }

  autoGenerateConfirmationNumber() {
    return this.http
      .get(this.url + '/autoGenerateConfirmationNumber', httpOptions)
      .pipe(retry(1));
  }

  // getBlackOutDates(tduEnrollmentDateRequest) {
  //   const userObj = JSON.stringify(tduEnrollmentDateRequest);
  //   return this.http
  //     .post(this.url + '/getBlackOutDatesInfo', userObj, httpOptions)
  //     .pipe(retry(1));
  // }

  getBlackOutDates(ProviderName = "",ESIID = "", IsMoving = false, ProductId = "", TDSP = "") {
    return this.http
      .get(this.url + '/getBlackOutDatesInfo?ProviderName=' + ProviderName + '&ESIID=' + ESIID + '&IsMoving=' + IsMoving + '&ProductId=' + ProductId + '&TDSP=' + TDSP  , httpOptions)
      .pipe(retry(1));
  }

  validateZipCode(zipcode: any) {
    const zipJson = JSON.stringify({
      Zip: zipcode,
    });
    return this.http.post(this.url + '/validateZipCode', zipJson, httpOptions);
  }

  updatePrepaidExcel() {
    return this.http
      .get(this.url + '/updatePrepaidExcel', httpOptions)
      .pipe(retry(1));
  }

  updateNotificationDetails(questionObj) {
    // let notificationObj = this.notificationObj;
    this.http
      .post(this.url + '/saveNotificationWindowClose', questionObj, httpOptions)
      .subscribe((notifyres: any) => {
        const notifyresult = notifyres;
      });
  }

  getCurrentDatePerCST() {
    let newDate = moment(new Date())
      .utc()
      .format('YYYY-MM-DD HH:mm:ss')
      .toString();
    var m = moment.utc(newDate);
    m.tz('America/Chicago');
    return m.format('MM/DD/YYYY HH:mm:ss');
  }

  toTitleCase(str) {
    return str
      .split(' ')
      .map((word) => word[0].toUpperCase() + word.substr(1).toLowerCase())
      .join(' ');
  }

  myBrowser() {
    if (
      (navigator.userAgent.indexOf('Opera') ||
        navigator.userAgent.indexOf('OPR')) != -1
    ) {
      return 'Opera';
    } else if (navigator.userAgent.indexOf('Chrome') != -1) {
      return 'Chrome';
    } else if (navigator.userAgent.indexOf('Safari') != -1) {
      return 'Safari';
    } else if (navigator.userAgent.indexOf('Firefox') != -1) {
      return 'Firefox';
    } else if (navigator.userAgent.indexOf('MSIE') != -1) {
      return 'IE';
    } else {
      return 'unknown';
    }
  }
  public postDataOfNewEnergyProvider(postobj): Observable<PostEnergyInfo> {
    return this.http
      .post<PostEnergyInfo>(
        this.url + '/postDataOfNewEnergyProvider',
        postobj,
        httpOptions
      )
      .pipe(retry(1));
  }
  public postPrepaidProvidersInfo(postobj) {
    return this.http
      .post(this.url + '/postPrepaidProvidersInfo', postobj, httpOptions)
      .pipe(retry(1));
  }
  public postDataOfNewEnergyProviderTDURates(postobj) {
    return this.http
      .post(
        this.url + '/postDataOfNewEnergyProviderTDURates',
        postobj,
        httpOptions
      )
      .pipe(retry(1));
  }
  public getEnergyProvidersReportInfo() {
    return this.http
      .get('/getEnergyProvidersReportInfo')
      .pipe(map((response) => response));
  }
  public getPrepaidProvidersInfo() {
    return this.http
      .get('/getPrepaidProvidersInfo')
      .pipe(map((response) => response));
  }
  public HgResEnergyProviderstduRates() {
    return this.http
      .get('/HgResEnergyProviderstduRates')
      .pipe(map((response) => response));
  }
  public getHgOrders() {
    return this.http.get('/getHgOrders').pipe(map((response) => response));
  }

  public deleteDataOfNewEnergyProvider(userObj) {
    return this.http
      .post(this.url + '/deleteDataOfNewEnergyProvider', userObj, httpOptions)
      .pipe(retry(1));
  }

  setDateValueForChariot(dob) {
    let month: any = new Date(dob).getMonth() + 1,
      day: any = new Date(dob).getDate();
    month = ('0' + month).slice(-2);
    day = ('0' + day).slice(-2);
    return `${month}/${day}/${new Date(dob).getFullYear()}`;
  }
  
  public SaveAffilationForm(postobj) {
    return this.http
      .post(
        this.url + '/SaveAffilationForm',
        postobj,
        httpOptions
      )
      .pipe(retry(1));
  }
  public GetAffilationById(id) {
    var obj = {"_id" : id};
    return this.http
      .post( this.url +'/GetAffilationById',obj,httpOptions)
      .pipe(map((response) => response));
  }
  public GetAllAffilations() {
    return this.http
      .get( this.url +'/GetAllAffilations')
      .pipe(map((response) => response));
  }

  public SavePromoCodeForm(postobj) {
    return this.http
      .post(
        this.url + '/SavePromoCodeForm',
        postobj,
        httpOptions
      )
      .pipe(retry(1));
  }
  public GetPromoCodeById(id) {
    var obj = {"_id" : id};
    return this.http
      .post( this.url +'/GetPromoCodeById',obj,httpOptions)
      .pipe(map((response) => response));
  }
  public CheckPromoExists(value,id) {
    var obj = {"_id" : id, "value" : value};
    return this.http
      .post( this.url +'/CheckPromoExists',obj,httpOptions)
      .pipe( delay(1000));
     //.pipe(retry(1));
  }
  
  public GetAllPromoCodes() {
    return this.http
      .get( this.url +'/GetAllPromoCodes')
      .pipe(map((response) => response));
  }
  private existingUsernames = ['Batman', 'Superman', 'Joker', 'Luthor'];
  public checkIfUsernameExists(value: string) {
    return of(this.existingUsernames.some((a) => a === value)).pipe(
      delay(1000)
    );
  }
  
  
  public ChangePromoStatus(postobj) {
    return this.http
      .post(
        this.url + '/ChangePromoStatus',
        postobj,
        httpOptions
      )
      .pipe(retry(1));
  }
  public ChangeAffliateStatus(postobj) {
    return this.http
      .post(
        this.url + '/ChangeAffliateStatus',
        postobj,
        httpOptions
      )
      .pipe(retry(1));
  }



  
  public GenerateLink(affiliate,promo) {
 
    var url_ = this.app_url;
    var both = false;

    if(affiliate != '' && affiliate != null && affiliate != undefined  && promo != '' && promo != null && promo != undefined  )
    {

      return url_ += "/ap/"+ affiliate +"/" + promo

    }

    if(promo != '' && promo != null && promo != undefined  )
    {
      return  url_ += "/p/"+promo
    }

    if(affiliate != '' && affiliate != null && affiliate != undefined  )
    {
      return  url_ += "/a/"+affiliate
    }

  }

ValidateAffiliatePromo(AffiliateName: any, Promo: any) {
  const obj = JSON.stringify({
    "Affiliate" : AffiliateName,
    "Promo" : Promo
  });
  return this.http.post(this.url + '/ValidateAffiliatePromo', obj, httpOptions);
}

UpdateAffliateStatus() {
  return this.http.post(this.url + '/UpdateAffliateStatus', httpOptions);
}

GETDepositWaiveReasons(ProviderName) {
    return this.http
    .get( this.url +'/GETDepositWaivers?ProviderName=' + ProviderName,)
    .pipe(map((response) => response));
}

public GetAllZipcodes() {
  return this.http
    .get( this.url +'/GetAllZipcodes')
    .pipe(map((response) => response));
}

public GetAllZipcodesById(id) {
  var obj = {"_id" : id};
  return this.http
    .post( this.url +'/GetAllZipcodesById',obj,httpOptions)
    .pipe(map((response) => response));
}

public SaveZipcodeForm(postobj) {
  return this.http
    .post(
      this.url + '/SaveZipcodeForm',
      postobj,
      httpOptions
    )
    .pipe(retry(1));
}

public DeleteZipcode(postobj) {
  return this.http
    .post(
      this.url + '/DeleteZipcode',
      postobj,
      httpOptions
    )
    .pipe(retry(1));
}

checkAdminLOgin()
{
  try{
    if(JSON.parse(sessionStorage.userObj).userObj.role != "Admin")
    {
      this.router.navigate(['/login']);
      return true;
    }else{
      return false;
    }


  }catch
  {
    this.router.navigate(['/login']);

    return true;
  }

 
}

SendFailedEnrollment(data, APIResponse, CompleteResponse, request = null)
{
 
      var obj = {
        "ProviderName" : data.selectedProduct.energy_provider,
        "CustomerName" : data.contactInfo.legalFirstName + " " + data.contactInfo.legalLastName,
        "PlanName": data.selectedProduct.product_key,
        "APIResponse": APIResponse,
        "Phone":data.contactInfo.phoneNo,
        "Email":data.contactInfo.emailId,
        "Contract Term": data.selectedProduct.terms,
        "500 kWh":(data.selectedProduct.tier[0].avg_charge * 100) .toFixed(1) + '¢',
        "1000 kWh":(data.selectedProduct.tier[1].avg_charge* 100) .toFixed(1) + '¢',
        "2000 kWh":(data.selectedProduct.tier[2].avg_charge* 100) .toFixed(1) + '¢',
        "Avg Price":(data.selectedProduct.new_tier.ave_price_per_KWH * 100) .toFixed(1) + '¢',
        "First Name": data.contactInfo.legalFirstName,
        "Last Name": data.contactInfo.legalLastName,
        "Avg Usage": Math.round(
          data.selectedProduct.new_tier.ave_monthly_usage
        ),
        "CompleteAPIResponse" : CompleteResponse,
        "Affiliate": data.Affiliate,
        "Promo": data.AffiliatePromo,
        "IP Address" : this.IPAddress
    
        
      };
    
      if(request != null)
      {
        obj["API Request"] = request
      }
    
    
      return this.http.post(this.url + '/SendFailedEnrollmentEmail', obj, httpOptions);
    
}

GetIDVerificationDetails_For_Rhythm(id)
{

  return this.http
      .post(this.url + '/GetIDVerificationDetails_For_Rhythm', id, httpOptions)
      .pipe(retry(0));
}

// The getIPAddress function remains the same
public getIPAddress(): Promise<string> {
  return fetch('https://api.ipify.org?format=json')
    .then(response => response.json())
    .then(data => data.ip)
    .catch(error => {
      console.error('Error fetching IP address:', error);
      return 'Unable to fetch IP';
    });
}

}